import React from 'react';
import DataPolicyPopup from './data-policy-popup';

const BASE = 'https://www.pinpointfieldservices.com';

const FooterGuest = () => (
  <footer style={{ backgroundColor: '#1a202c', color: '#a0aec0', padding: '3rem 0 1.5rem' }}>
    <div className="container">

      {/* Link Groups */}
      <div className="row g-4 mb-5">

        {/* Services */}
        <div className="col-6 col-md-3">
          <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#e2e8f0', marginBottom: '0.75rem' }}>
            Services
          </p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/services/mobile-notary-closing/`} style={linkStyle}>Mobile Notary Closings</a>
            </li>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/services/remote-online-notarization/`} style={linkStyle}>Remote Online Notarization</a>
            </li>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/services/property-condition-photos/`} style={linkStyle}>Property Condition Photos</a>
            </li>
          </ul>
        </div>

        {/* Who We Work With */}
        <div className="col-6 col-md-3">
          <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#e2e8f0', marginBottom: '0.75rem' }}>
            Who We Work With
          </p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/industries/title-companies/`} style={linkStyle}>For Title Companies</a>
            </li>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/industries/real-estate-attorneys/`} style={linkStyle}>For Real Estate Attorneys</a>
            </li>
            <li style={{ marginBottom: '0.4rem' }}>
              <a href={`${BASE}/industries/mortgage-lenders/`} style={linkStyle}>For Mortgage Lenders</a>
            </li>
          </ul>
        </div>

        {/* Top Markets */}
        <div className="col-12 col-md-6">
          <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#e2e8f0', marginBottom: '0.75rem' }}>
            Top Markets
          </p>
          <div className="row g-0">

            <div className="col-6 col-sm-3 mb-3">
              <p style={regionLabelStyle}>Texas</p>
              <ul style={ulStyle}>
                <li><a href={`${BASE}/mobile-notary/texas/san-antonio/`} style={linkStyle}>San Antonio, TX</a></li>
                <li><a href={`${BASE}/mobile-notary/texas/dallas/`} style={linkStyle}>Dallas, TX</a></li>
                <li><a href={`${BASE}/mobile-notary/texas/fort-worth/`} style={linkStyle}>Fort Worth, TX</a></li>
              </ul>
            </div>

            <div className="col-6 col-sm-3 mb-3">
              <p style={regionLabelStyle}>Southwest</p>
              <ul style={ulStyle}>
                <li><a href={`${BASE}/mobile-notary/arizona/phoenix/`} style={linkStyle}>Phoenix, AZ</a></li>
                <li><a href={`${BASE}/mobile-notary/colorado/denver/`} style={linkStyle}>Denver, CO</a></li>
                <li><a href={`${BASE}/mobile-notary/nevada/las-vegas/`} style={linkStyle}>Las Vegas, NV</a></li>
              </ul>
            </div>

            <div className="col-6 col-sm-3 mb-3">
              <p style={regionLabelStyle}>Florida</p>
              <ul style={ulStyle}>
                <li><a href={`${BASE}/mobile-notary/florida/miami/`} style={linkStyle}>Miami, FL</a></li>
                <li><a href={`${BASE}/mobile-notary/florida/orlando/`} style={linkStyle}>Orlando, FL</a></li>
              </ul>
            </div>

            <div className="col-6 col-sm-3 mb-3">
              <p style={regionLabelStyle}>Midwest</p>
              <ul style={ulStyle}>
                <li><a href={`${BASE}/mobile-notary/illinois/chicago/`} style={linkStyle}>Chicago, IL</a></li>
                <li><a href={`${BASE}/mobile-notary/missouri/kansas-city/`} style={linkStyle}>Kansas City, MO</a></li>
              </ul>
            </div>

          </div>
          <a href={`${BASE}/mobile-notary/`} style={{ ...linkStyle, fontSize: '0.85rem', fontWeight: '600' }}>
            See all 28 cities →
          </a>
        </div>

      </div>

      {/* Divider */}
      <hr style={{ borderColor: '#2d3748', margin: '0 0 1.5rem' }} />

      {/* Bottom bar */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3" style={{ fontSize: '0.85rem' }}>
        <div>
          <p style={{ margin: '0 0 0.25rem', color: '#e2e8f0' }}>
            <a href="tel:888-530-7592" style={{ color: '#00bfff', textDecoration: 'none', fontWeight: '600' }}>(888) 530-7592</a>
          </p>
          <p style={{ margin: 0 }}>
            © {new Date().getFullYear()} Pinpoint Field Services, LLC. All Rights Reserved.
          </p>
          <p style={{ margin: 0 }}>PO Box 541026 · Omaha, NE 68154</p>
        </div>
        <div className="d-flex align-items-center gap-3">
          <a
            href="https://www.linkedin.com/company/pinpoint-field-services"
            target="_blank"
            rel="noopener noreferrer"
            style={{ opacity: 0.8 }}
          >
            <img src="../img/In-Blue-14@2x.png" alt="LinkedIn" style={{ height: '20px' }} />
          </a>
          <a href="https://icons8.com" target="_blank" rel="noopener noreferrer" style={{ ...linkStyle, fontSize: '0.75rem' }}>
            Icons by Icons8
          </a>
          <DataPolicyPopup />
        </div>
      </div>

    </div>
  </footer>
);

const linkStyle = {
  color: '#a0aec0',
  textDecoration: 'none',
  fontSize: '0.875rem',
  lineHeight: '1.8',
  display: 'block',
};

const regionLabelStyle = {
  fontSize: '0.7rem',
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  color: '#718096',
  marginBottom: '0.3rem',
};

const ulStyle = {
  listStyle: 'none',
  padding: 0,
  margin: '0 0 0.5rem',
};

export default FooterGuest;
